import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import ErrorField from "./components/ErrorField";
import { VTextField } from 'vuetify/lib';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import tinymce from 'vue-tinymce-editor'
import VueScrollTo from 'vue-scrollto'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
 


Vue.use(VueScrollTo)
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })


Vue.component('v-text-field', VTextField);
Vue.component('tinymce', tinymce)


Vue.use(VueSweetalert2);
Vue.use(VueReCaptcha, { siteKey: '6LcMMeMUAAAAAOtrYLD_8islfm62gKsyjKKg283n' })

Vue.config.produtionTip = false;
Vue.component("error-field", ErrorField);

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyC7uo9Rqb3LhfQiXRGAWmx3rqi663eOwac', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  language: 'en-US'
});

import "./plugins/axios";
import "./plugins/toasted";


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
